/**
 * FAQs Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the FAQs section.
 *
 * @namespace faqs
 */

import { register } from '@shopify/theme-sections'
import { getElement, getElements, styleToNumber } from '../utils/functional'
import { slideDown, slideUp } from '../utils'

const selectors = {
  container: '[data-faqs]',
  item: '[data-faqs-item]',
  question: '[data-faqs-question]',
  answer: '[data-faqs-answer]'
}

register('faqs', {
  onLoad () {
    const _this = this
    const elements = {
      container: getElement(selectors.container)
    }

    this.options = {
      startClosed: elements.container.dataset.faqsClosed === 'true',
      openOneAtATime: elements.container.dataset.faqsOneAtATime === 'true'
    }
    this.faqs = getElements(selectors.item).map(el => {
      return {
        els: {
          el,
          question: getElement(selectors.question, { context: el }),
          answer: getElement(selectors.answer, { context: el })
        },
        _isOpen: el.getAttribute('aria-expanded') === 'true',
        get isOpen () {
          return this._isOpen
        },
        set isOpen (val) {
          this._isOpen = val

          if (val) {
            this.els.el.setAttribute('aria-expanded', String(val))
            slideDown(this.els.answer, _this.getAnswerHeight(this.els.answer))

            if (_this.options.openOneAtATime === true) {
              _this.faqs
                .filter(faq => faq.els.el !== this.els.el)
                .forEach(faq => (faq.isOpen = false))
            }
          } else {
            slideUp(
              this.els.answer,
              _this.getAnswerHeight(this.els.answer)
            ).then(() => {
              this.els.el.setAttribute('aria-expanded', String(val))
              this.els.answer.removeAttribute('style')
            })
          }
        }
      }
    })

    this.setupListeners()
  },

  setupListeners () {
    this.faqs.forEach(faq => {
      faq.els.question.addEventListener(
        'click',
        () => (faq.isOpen = !faq.isOpen)
      )
    })
  },

  getAnswerHeight (el) {
    el.style.display = 'block'
    const style = window.getComputedStyle(el)
    const height =
      el.offsetHeight +
      styleToNumber(style.marginTop) +
      styleToNumber(style.marginBottom)
    el.style.display = ''

    return height
  }
})
